/* Theme-level guard only. Shopify admin/server validation must lock direct checkout. */
(() => {
  if (window.sfMarketplaceGuard) return;
  window.sfMarketplaceGuard = true;
  const blocked = (raw, isForm = false) => {
    try {
      const url = new URL(raw, window.location.href);
      if (url.origin !== window.location.origin) return false;
      const path = url.pathname.replace(/\/$/, '');
      return /\/(checkouts?)(\/|$)/i.test(path) ||
        /\/cart\/\d+[:%]/i.test(path) ||
        (/\/cart$/i.test(path) && url.searchParams.has('checkout')) ||
        (isForm && /\/cart(?:\/(add|change|update|clear)(\.js)?)?$/i.test(path));
    } catch { return false; }
  };
  const stop = event => {
    event.preventDefault(); event.stopImmediatePropagation();
    let note = document.querySelector('[data-sf-marketplace-guard-note]');
    if (!note) {
      note = document.createElement('p'); note.dataset.sfMarketplaceGuardNote = '';
      note.className = 'sf-marketplace-guard-note'; note.setAttribute('role', 'status');
      document.body.append(note);
    }
    note.textContent = 'Purchases are available on marketplaces. Open a product, then choose a store.';
    clearTimeout(window.sfMarketplaceNoticeTimer);
    window.sfMarketplaceNoticeTimer = setTimeout(() => note.remove(), 6000);
  };
  document.addEventListener('submit', event => {
    if (blocked(event.target.action, true) || event.submitter?.name === 'checkout') stop(event);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    const button = event.target.closest?.('[name="checkout"], [name="add"]');
    if ((link && blocked(link.href)) || button) stop(event);
  }, true);
})();
